"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaTippyIconWrap = exports.FelaIconWrap = exports.ruleKeysFelaIconWrap = exports.ButtonRules = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ColorUtils_1 = require("@gt/common-utils/build/general/ColorUtils");
const FelaCache_1 = require("../../fela/FelaCache");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaCommon_1 = require("./FelaCommon");
const FelaLayers_1 = require("./FelaLayers");
const FelaText_1 = require("./FelaText");
const FelaTippy_1 = require("./FelaTippy");
const FelaRuleIconWrap = ({ theme, sizeNum, size, isButton = false, contrast = FelaCommon_1.EGraphicContrast.MID, noBackground = false, noPadding = false, neutralColor, color, colorString, iconFilter, disabled = false, fillAlso = false, fullWidth = false, forceTheme, }) => {
    let sizeNumVal = theme.styles.Font.sizes[VibescoutFrontendStyleConfig_1.ETextSize.content] * 1.25;
    const foreContrast = FelaCommon_1.contrastToFore[contrast];
    if (fullWidth) {
        sizeNumVal = "100%";
    }
    else if (size) {
        sizeNum = theme.styles.Font.sizes[size] * 1.25;
        sizeNumVal = theme.styles.Font.sizes[size] * 1.25;
    }
    else if (sizeNum) {
        sizeNumVal = sizeNum;
    }
    if (!colorString) {
        if (neutralColor) {
            colorString = theme.styles.RgbColors.neutral[neutralColor];
        }
    }
    //FelaUtility.getForeRgbColorForThemeAndContrast(theme, contrast)
    const colorMade = colorString
        ? colorString
        : color !== undefined
            ? `rgb(${color[0]})`
            : theme.styles.Themes[forceTheme ?? theme.currentId].RgbColors.fore[foreContrast];
    const colorMadeHover = `rgb(${ColorUtils_1.ColorUtils.lightenRgbArray(color !== undefined
        ? color
        : theme.styles.Themes[forceTheme ?? theme.currentId].Colors.fore[foreContrast], 20)[0]})`;
    // : FelaUtility.getForeRgbColorForThemeAndContrast(theme, contrast, true);
    return {
        ...(!noPadding && {
            padding: (sizeNum ?? 2) / 4,
        }),
        zIndex: 1,
        boxSizing: "content-box",
        width: sizeNumVal,
        height: sizeNumVal,
        borderRadius: "100%",
        display: "inline-block",
        cursor: isButton ? "pointer" : "auto",
        "& svg": {
            width: sizeNumVal,
            height: sizeNumVal,
            color: colorMade,
            fill: fillAlso ? colorMade : undefined,
            transition: "color 0.15s ease-in-out",
            ...(iconFilter != null && {
                filter: iconFilter,
            }),
        },
        ...(isButton
            ? {
                ":hover": {
                    "& svg": {
                        color: colorMadeHover,
                        fill: fillAlso ? colorMadeHover : undefined,
                    },
                },
            }
            : {
                pointerEvents: "none",
            }),
        ...(noBackground && {
            background: "none",
        }),
    };
};
exports.ButtonRules = {
    iconButton: FelaRuleIconWrap,
};
exports.ruleKeysFelaIconWrap = [
    "theme",
    "sizeNum",
    "size",
    "isButton",
    "contrast",
    "noBackground",
    "noPadding",
    "neutralColor",
    "color",
    "colorString",
    "iconFilter",
    "disabled",
    "fillAlso",
    "fullWidth",
    "forceTheme",
];
const FelaIconWrapSuperRule = (0, FelaCache_1.combineRulesWithName)([FelaLayers_1.FelaRuleLayer, FelaRuleIconWrap], "FelaIconWrapSuperRule");
const ruleKeysFelaIconWrapSuper = [...new Set([...exports.ruleKeysFelaIconWrap, ...FelaLayers_1.ruleKeysFlexLayer])];
const FelaIconWrap = ({ children, className = "", style, cssExtra = [], onClick, onMouseEnter, onMouseLeave, innerHtml, ref, cssKey, 
// backgroundImage,
...props }) => {
    if (props.clickable || onClick != null) {
        props.isButton = true;
    }
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    const divProps = {
        onMouseEnter,
        onMouseLeave,
        onClick,
    };
    if (innerHtml) {
        divProps.dangerouslySetInnerHTML = { __html: innerHtml };
    }
    return ((0, jsx_runtime_1.jsx)("div", { 
        // dangerouslySetInnerHTML={innerHtml ? { __html: innerHtml } : undefined}
        ref: ref, style: style, 
        // className={`${className} ${css(FelaRuleLayer, FelaRuleIconWrap, ...cssExtra)}`}
        className: `${className} ${cachedClass(FelaIconWrapSuperRule, props, cssKey ?? ruleKeysFelaIconWrapSuper)} ${inlineCss(cssExtra)}`, ...divProps, children: children }));
};
exports.FelaIconWrap = FelaIconWrap;
const FelaTippyIconWrap = ({ tippyFullContent, tippyTextContent, onClickIcon, iconProps = {}, children, }) => {
    return ((0, jsx_runtime_1.jsx)(FelaTippy_1.FelaTippy, { content: tippyFullContent ? (tippyFullContent) : ((0, jsx_runtime_1.jsx)(FelaText_1.FelaText, { contrast: FelaCommon_1.EGraphicContrast.HIGH, children: tippyTextContent })), children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(exports.FelaIconWrap, { onClick: onClickIcon, height: FelaLayers_1.EFelaLayerHeight.HIGH, contrast: FelaCommon_1.EGraphicContrast.HIGH, shadow: true, margin: 0.25, size: VibescoutFrontendStyleConfig_1.ETextSize.content, isButton: true, clickable: true, hoverable: true, ...iconProps, children: children }) }) }));
};
exports.FelaTippyIconWrap = FelaTippyIconWrap;
